import { IPagination } from 'app/types/common';

export interface IOrganisationSubscriptionsState {
  readonly organisationSubscriptionsById?: any;
  readonly organisationSubscriptionIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectOrganisationSubscriptionLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddOrganisationSubscription?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationOrganisationSubscriptionIds?: string[];
  readonly currentOrganisationSubscriptionId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IOrganisationSubscriptionsSelector
  extends IOrganisationSubscriptionsState {
  readonly currentOrganisationSubscription?: any;
  readonly currentFormOrganisationSubscription?: any;
  readonly organisationSubscriptionsFilteredByOrganisationInSelectFormat?: any;
  readonly organisationSubscriptionsByTagAndIdInSelectFormat?: any;
  readonly organisationSubscriptionsByIdInSelectFormat?: any;
  readonly organisationSubscriptionsFilteredByCompetitionInSelectFormat?: any;
  readonly organisationSubscriptionsFilteredByIdInSelectFormat?: any;
}

export enum OrganisationSubscriptionsActionTypes {
  GET_ALL_ORGANISATION_SUBSCRIPTIONS_REQUESTED = 'redux-app/organisation-subscriptions/GET_ALL_ORGANISATION_SUBSCRIPTIONS_REQUESTED',
  GET_ALL_ORGANISATION_SUBSCRIPTIONS_PENDING = 'redux-app/organisation-subscriptions/GET_ALL_ORGANISATION_SUBSCRIPTIONS_PENDING',
  GET_ALL_ORGANISATION_SUBSCRIPTIONS_SUCCESS = 'redux-app/organisation-subscriptions/GET_ALL_ORGANISATION_SUBSCRIPTIONS_SUCCESS',
  GET_ALL_ORGANISATION_SUBSCRIPTIONS_FAIL = 'redux-app/organisation-subscriptions/GET_ALL_ORGANISATION_SUBSCRIPTIONS_FAIL',
  GET_ORGANISATION_SUBSCRIPTION_REQUESTED = 'redux-app/organisation-subscriptions/GET_ORGANISATION_SUBSCRIPTION_REQUESTED',
  GET_ORGANISATION_SUBSCRIPTION_PENDING = 'redux-app/organisation-subscriptions/GET_ORGANISATION_SUBSCRIPTION_PENDING',
  GET_ORGANISATION_SUBSCRIPTION_SUCCESS = 'redux-app/organisation-subscriptions/GET_ORGANISATION_SUBSCRIPTION_SUCCESS',
  GET_ORGANISATION_SUBSCRIPTION_FAIL = 'redux-app/organisation-subscriptions/GET_ORGANISATION_SUBSCRIPTION_FAIL',
  UPDATE_ORGANISATION_SUBSCRIPTION_REQUESTED = 'redux-app/organisation-subscriptions/UPDATE_ORGANISATION_SUBSCRIPTION_REQUESTED',
  UPDATE_ORGANISATION_SUBSCRIPTION_PENDING = 'redux-app/organisation-subscriptions/UPDATE_ORGANISATION_SUBSCRIPTION_PENDING',
  UPDATE_ORGANISATION_SUBSCRIPTION_SUCCESS = 'redux-app/organisation-subscriptions/UPDATE_ORGANISATION_SUBSCRIPTION_SUCCESS',
  UPDATE_ORGANISATION_SUBSCRIPTION_FAIL = 'redux-app/organisation-subscriptions/UPDATE_ORGANISATION_SUBSCRIPTION_FAIL',
  CREATE_ORGANISATION_SUBSCRIPTION_REQUESTED = 'redux-app/organisation-subscriptions/CREATE_ORGANISATION_SUBSCRIPTION_REQUESTED',
  CREATE_ORGANISATION_SUBSCRIPTION_PENDING = 'redux-app/organisation-subscriptions/CREATE_ORGANISATION_SUBSCRIPTION_PENDING',
  CREATE_ORGANISATION_SUBSCRIPTION_SUCCESS = 'redux-app/organisation-subscriptions/CREATE_ORGANISATION_SUBSCRIPTION_SUCCESS',
  CREATE_ORGANISATION_SUBSCRIPTION_FAIL = 'redux-app/organisation-subscriptions/CREATE_ORGANISATION_SUBSCRIPTION_FAIL',
  DELETE_ORGANISATION_SUBSCRIPTION_REQUESTED = 'redux-app/organisation-subscriptions/DELETE_ORGANISATION_SUBSCRIPTION_REQUESTED',
  DELETE_ORGANISATION_SUBSCRIPTION_PENDING = 'redux-app/organisation-subscriptions/DELETE_ORGANISATION_SUBSCRIPTION_PENDING',
  DELETE_ORGANISATION_SUBSCRIPTION_SUCCESS = 'redux-app/organisation-subscriptions/DELETE_ORGANISATION_SUBSCRIPTION_SUCCESS',
  DELETE_ORGANISATION_SUBSCRIPTION_FAIL = 'redux-app/organisation-subscriptions/DELETE_ORGANISATION_SUBSCRIPTION_FAIL',
  SELECT_ORGANISATION_SUBSCRIPTION_REQUESTED = 'redux-app/organisation-subscriptions/SELECT_ORGANISATION_SUBSCRIPTION_REQUESTED',
}

export default null;
